let smoother;

document.addEventListener('DOMContentLoaded', function () {
  gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

  ScrollTrigger.normalizeScroll(false);

  smoother = ScrollSmoother.create({
    smooth: 2,
    effects: true,
  });

  // if (document.location.pathname.length > 1) {
  //   let nextSection = document.querySelector('.go-to-next');
  //   nextSection.addEventListener('click', (e) => {
  //     smoother.scrollTo('.nextep-function', true, 'center center');
  //   });
  // }
  gsap.utils.toArray('.go-to-next').forEach(function (button, i) {
    button.addEventListener('click', (e) => {
      var id = e.target.getAttribute('href');
      console.log(id);
      smoother.scrollTo(id, true, 'top top');
      e.preventDefault();
    });
  });
});

// gsap.utils.toArray('.nav a').forEach(function (button, i) {
//   button.addEventListener('click', (e) => {
//     var id = e.target.getAttribute('href');
//     console.log(id);
//     smoother.scrollTo(id, true, 'top top');
//     e.preventDefault();
//   });
// });

// // to view navigate to -  https://cdpn.io/pen/debug/XWVvMGr#section3
// window.onload = (event) => {
//   console.log('page is fully loaded');

//   let urlHash = window.location.href.split('#')[1];

//   let scrollElem = document.querySelector('#' + urlHash);

//   console.log(scrollElem, urlHash);

//   if (urlHash && scrollElem) {
//     gsap.to(smoother, {
//       scrollTop: smoother.offset(scrollElem, 'top top'),
//       duration: 1,
//       delay: 0.5,
//     });
//   }
// };
